export default "__VITE_ASSET__DCn4Mjhv__"